module.exports = __webpack_public_path__ + "img/avatar-default-icon.18413bfa.png";